import { render } from "./significance_ploat.vue?vue&type=template&id=1810b581"
import script from "./significance_ploat.vue?vue&type=script&lang=js"
export * from "./significance_ploat.vue?vue&type=script&lang=js"

import "./significance_ploat.vue?vue&type=style&index=0&id=1810b581&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__